"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/ProgressBar/index.js";
function ProgressBar(_ref) {
  var className = _ref.className,
    progress = _ref.progress,
    children = _ref.children;
  var classes = (0, _classNames["default"])(className, 'progress');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    role: "progressbar",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress-bar",
    style: {
      width: "".concat(progress, "%")
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 13
    }
  }, children));
}
var _default = exports["default"] = ProgressBar;